/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useCallback, useState } from "react"
import { formatMoney } from "../../utils/tb/formatMoney"
import * as S from "./styled"

import { ReactComponent as DropdownIcon } from "../../assets/icons/dropdown.svg"

import { TTicketDisposal } from "../../utils/@types/data/ticket"
import { Api } from "../../api"
import getStore from "../../store"
import {
  eventHasTaxes,
  getAdditionalTax,
  sumTaxes,
  sumTickets,
} from "../../utils/tb/taxes"
import { useNavigate } from "react-router-dom"

type Props = {
  hideEventData?: boolean
  datePeriod?: string
  ticketsList: TTicketDisposal[]
  setTickets?: (list: TTicketDisposal[]) => void
  onlyPurchasingItems?: boolean
  fitContainer?: boolean
  reverse?: boolean
  paymentMethod?: "" | "pix" | "credit"
}

const OrderResume = ({
  hideEventData = false,
  datePeriod,
  ticketsList,
  onlyPurchasingItems = false,
  fitContainer = false,
  reverse = false,
  paymentMethod = "",
}: Props) => {
  const navigate = useNavigate()

  const { event, controllers } = getStore()

  const [resumeExpanded, setResumeExpanded] = useState(true)

  const [taxes, setTaxes] = useState({
    value: 0,
    rule: "",
    strComplement: "",
  })
  const [ticketsTotal, setTicketsTotal] = useState(0)

  const loadEventData = useCallback(async () => {
    if (event) {
      try {
        const req = await Api.get.eventInfo({ eventId: event?.id })

        if (req.ok) {
          const data = req.data
          sessionStorage.setItem("event", JSON.stringify(data))
          controllers.event.setData(data)
        }
      } catch (error) {
        alert("Erro ao carregar os tickets")
        navigate("/")
      }
    } else {
      navigate("/")
    }
  }, [])

  const sumValues = () => {
    try {
      if (event && event.eCommerce) {
        const ticketsTotal = sumTickets(ticketsList)
        const taxesTotal = sumTaxes({
          ticketsTotal,
          adminTax: event.eCommerce.adminTax,
          adminTaxMinimum: +event.eCommerce.adminTaxMinimum,
          adminTaxPercentage: +event.eCommerce.adminTaxPercentage,
          adminTaxValue: +event.eCommerce.adminTaxValue,
          tickets: ticketsList,
        })

        setTaxes(taxesTotal)
        setTicketsTotal(ticketsTotal)
      }
    } catch (error) {
      alert("Erro ao carregar os tickets")
      navigate("/")
    }
  }

  useEffect(() => {
    loadEventData()
  }, [loadEventData])

  useEffect(() => {
    if (event && event.eCommerce) sumValues()
  }, [ticketsList, event])

  const handleExpandResume = () => {
    setResumeExpanded(!resumeExpanded)
  }

  const baseTotal = event?.eCommerce?.chargeClient
    ? ticketsTotal + taxes.value
    : ticketsTotal

  const additionalTax = getAdditionalTax({
    baseTotal: ticketsTotal,
    method: paymentMethod,
    additionalTaxCard: event?.eCommerce?.additionalTaxCard,
    additionalTaxPix: event?.eCommerce?.additionalTaxPix,
  })

  const platformTax =
    event?.eCommerce?.chargeClient && eventHasTaxes(event) ? taxes.value : 0
  const serviceTax = platformTax + additionalTax

  const displayTickets = (
    onlyPurchasingItems
      ? ticketsList.filter((i) => i.qnt > 0)
      : ticketsList
  ).filter((t) => t.qnt > 0)

  return (
    <S.Component $fitContainer={fitContainer} $reverse={reverse}>
      {event?.event_banner && (
        <S.ImageContainer>
          <img src={event?.event_banner} alt={""} />
        </S.ImageContainer>
      )}

      <S.Info>
        <S.ResumeHeader
          onClick={handleExpandResume}
          role="button"
          aria-expanded={resumeExpanded}
          aria-label={
            resumeExpanded
              ? "Recolher resumo do pedido"
              : "Expandir resumo do pedido"
          }
          $expanded={resumeExpanded}
        >
          <S.ResumeText>Resumo do pedido</S.ResumeText>
          <DropdownIcon />
        </S.ResumeHeader>

        <S.InfoWrapper $expanded={resumeExpanded}>
          <S.InfoData>
            <S.InfoContent>
              {!hideEventData && datePeriod && (
                <S.DateBlock>
                  <S.DateLabel>Data</S.DateLabel>
                  <S.DateValue>{datePeriod}</S.DateValue>
                </S.DateBlock>
              )}

              {displayTickets.length > 0 && (
                <S.ItemsSection>
                  <S.ItemsHead>
                    <span>Item</span>
                    <span>Qtd</span>
                    <span>Subtotal</span>
                  </S.ItemsHead>
                  {displayTickets.map((ticket, k) => (
                    <S.ItemRow key={k}>
                      <S.ItemName>{ticket.name}</S.ItemName>
                      <S.ItemQty aria-label={`Quantidade: ${ticket.qnt}`}>
                        {ticket.qnt}
                      </S.ItemQty>
                      <S.ItemSubtotal>
                        {formatMoney(ticket.price_sell * ticket.qnt, true)}
                      </S.ItemSubtotal>
                    </S.ItemRow>
                  ))}
                </S.ItemsSection>
              )}
            </S.InfoContent>
          </S.InfoData>
        </S.InfoWrapper>

        <S.Total>
          <S.TotalItem>
            <span>Subtotal</span>
            <span>{formatMoney(ticketsTotal, true)}</span>
          </S.TotalItem>
          {serviceTax > 0 && (
            <S.TotalItem>
              <span>Taxa de serviço {additionalTax > 0 ? "" : taxes.strComplement}</span>
              <span>{formatMoney(serviceTax, true)}</span>
            </S.TotalItem>
          )}
          <S.TotalItem $main={true}>
            <span>Total</span>
            <span>{formatMoney(baseTotal + additionalTax, true)}</span>
          </S.TotalItem>
        </S.Total>
      </S.Info>
    </S.Component>
  )
}

export default OrderResume
